// ExportCVPanelDialog.tsx — Export the active panel as a .cvpanel file

import DialogBase from './DialogBase';
import { useShallowStore } from '../store/useStore';
import { exportPanelCVPanel } from '../utils/cvpFormat';

export default function ExportCVPanelDialog() {
  const { ui, project } = useShallowStore(s => ({ ui: s.ui, project: s.project }));
  const panel = project?.panels.find(p => p.id === ui.activePanelId);

  return (
    <DialogBase
      title="Export Panel (.cvpanel)"
      okLabel="Export"
      onOk={() => panel && exportPanelCVPanel(panel)}
    >
      {panel ? (
        <>
          <p className="dialog-info">
            Exporting panel <strong>{panel.mpvar.panelMark}</strong> as a native CV panel file.
          </p>
          <p className="dialog-info">
            All 21 entity groups are included (openings, blockouts, features, structural, etc.).
          </p>
          <p className="dialog-info">
            Import into any project with File → Import CV File to add this panel.
          </p>
        </>
      ) : (
        <p className="dialog-warning">No panel selected. Please select a panel first.</p>
      )}
    </DialogBase>
  );
}
